import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import PersonIcon from '@mui/icons-material/Person';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button, FormControl, Grid, InputLabel } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { guardarTokenSesion } from '../utils/cookies';


export const Login = ({ username, setUsername, password, setPassword }) => {
    const navigate = useNavigate();
    const wsUrl = "www.elpelobetxi.com";
    const [showPassword, setShowPassword] = useState(false);



    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleLogin();
        }
    };

    const handleLogin = async () => {
        try {
            const response = await axios.post(`https://${wsUrl}/WS/login.php`, {
                mail: username,
                password: password,
            });
            if (response.data.success) {
                // Guarda el token en una cookie con fecha de expiraci?n.
                const tokenExpiryDate = new Date();
                tokenExpiryDate.setTime(tokenExpiryDate.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 dies
                guardarTokenSesion(response.data.token, tokenExpiryDate);

                // Guarda otros datos en el almacenamiento local.
                localStorage.setItem('username', response.data.nombre);
                localStorage.setItem('mail', response.data.mail);
                localStorage.setItem('DesRepresentante', response.data.nombre);
                window.dispatchEvent(new Event('penya-auth-changed'));

                setPassword('');
                setUsername('');

                Swal.fire({
                    icon: "success",
                    title: `Benvingut/da \n${response.data.nombre}`,
                    showConfirmButton: false,
                    timer: 1500
                });
                navigate('/');
            } else {
                Swal.fire({
                    icon: "error",
                    title: `Error d'inici de sessi?: \n${response.data.message}`,
                    showConfirmButton: false,
                    timer: 1500
                });
            }
        } catch (error) {
            console.error('Error de xarxa:', error.message);
        }
    };
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    return (
        <Grid
            container
            direction="row"
            className='load fondo-verde'
            style={{ minHeight: '100vh' }}
            size={{ xs: 12 }}
            sx={{ justifyContent: "center", alignItems: "flex-start" }}>

            <Grid
                container
                direction="row"
                size={{ xs: 12 }}
                sx={{ justifyContent: "center", alignItems: "flex-start", marginTop: '10em' }}>
                <Grid
                    container
                    direction="column"
                    spacing={1}
                    className='bordes-redondos fondo-blanco sombra-corta'
                    size={{ xs: 11, sm: 8, md: 6, xl: 3 }}
                    sx={{ justifyContent: "center", alignItems: "center" }}>
                    <Grid
                        container
                        direction="column"
                        // style={{ marginBottom: '-2em' }}
                        size={{ xs: 12 }}
                        sx={{ justifyContent: "center", alignItems: "center" }}>
                        <PersonIcon sx={{ fontSize: 80 }} style={{ marginBottom: '-0.3em' }} color='primary' />
                        <h1>Iniciar sessió</h1>
                    </Grid>

                    <Grid
                        container
                        direction="column"
                        // style={{ marginBottom: '-1em' }}
                        size={{ xs: 11, sm: 8, md: 8, xl: 8 }}
                        sx={{ justifyContent: "flex-start", alignItems: "flex-start" }}>
                        {/* <h2>Correu electr?nic</h2> */}
                        <TextField name='email' id="outlined-basic" label="Correu electrònic" variant="outlined" color='primary' style={{ minWidth: '100%' }} onChange={(e) => setUsername(e.target.value)} onKeyPress={handleKeyPress} />
                    </Grid>

                    <Grid
                        container
                        direction="column"
                        style={{ marginBottom: '0.5em' }}
                        size={{ xs: 11, sm: 8, md: 8, xl: 8 }}
                        sx={{ justifyContent: "flex-start", alignItems: "flex-start" }}>
                        {/* <h2>Contrasenya</h2> */}
                        <FormControl variant="outlined" style={{ minWidth: '100%' }} onKeyPress={handleKeyPress}>
                            <InputLabel htmlFor="outlined-adornment-password" color='primary' >Contrasenya</InputLabel>
                            <OutlinedInput
                                name='password'
                                color='primary'
                                id="outlined-adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Mostrar o ocultar contrasenya"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label="Contrasenya"
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </FormControl >
                    </Grid>

                    <Grid
                        container
                        direction="column"
                        // style={{ marginBottom: '1em' }}
                        size={{ xs: 11, sm: 8, md: 8, xl: 8 }}
                        sx={{ justifyContent: "flex-start", alignItems: "flex-start" }}>
                        <Button
                            variant="contained"
                            color='primary'
                            style={{ minWidth: '100%' }}
                            onClick={() => handleLogin()}
                        // disabled={username == '' && password == '' ? false : true}
                        >
                            Iniciar sessió&nbsp;<LoginIcon fontSize='small' />
                        </Button>
                    </Grid>
                    {/* <Grid
                        container
                        direction="column"
                        style={{ marginBottom: '1em' }}
                size={{ xs: 11, sm: 8, md: 8, xl: 8 }}
                sx={{ justifyContent: "flex-start", alignItems: "flex-start" }}>
                        <Button variant="outlined" color='primary' style={{ minWidth: '100%' }} onClick={() => navigate("/registrarse")}>Registrar-se&nbsp;<PersonAddAltIcon fontSize='small' /></Button>
                    </Grid> */}

                </Grid>

            </Grid>

            {/* <PiePagina></PiePagina> */}
        </Grid>

    )
};
